import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  isDevMode,
  OnChanges,
} from '@angular/core';

@Directive({
  selector: '[focusOnInit]',
})
export class FocusOnInitDirective implements AfterViewInit, OnChanges {
  @Input('focusOnInit') shouldFocus: boolean = true;
  private focusOnChange: boolean = false;

  constructor(private readonly el: ElementRef) {}

  ngAfterViewInit() {
    if (this.shouldFocus) {
      this.focus();
    } else {
      this.focusOnChange = true;
    }
  }

  ngOnChanges() {
    if (this.focusOnChange && this.shouldFocus) {
      this.focusOnChange = false;
      this.focus();
    }
  }

  private focus() {
    if (!this.el.nativeElement.hasAttribute('tabindex')) {
      this.el.nativeElement.tabIndex = 0;
      if (isDevMode()) {
        this.reportTabIndexWarning();
      }
    }
    if (isDevMode()) {
      this.reportVisibilityWarning();
    }
    this.el.nativeElement.focus();
  }

  reportTabIndexWarning() {
    /* eslint-disable no-console */
    console.group();
    console.warn(
      `The [focusOnInit] directive was used on an element with no tabindex, so a default (${this.el.nativeElement.tabIndex}) was added programmatically. Add the tabindex attribute to this element to suppress this warning.`,
    );
    console.log(this.el.nativeElement);
    console.groupEnd();
    /* eslint-enable no-console */
  }

  reportVisibilityWarning() {
    /* eslint-disable no-console */
    const warnings = [];
    const styles = window.getComputedStyle(this.el.nativeElement);
    if (styles.display === 'none') {
      warnings.push(`display: none`);
    }
    if (styles.visibility === 'hidden') {
      warnings.push(`visibility: hidden`);
    }
    if (warnings.length) {
      console.group();
      console.warn(
        `You are trying to use the [focusOnInit] directive, but the element is not visible (${warnings.join(
          ', ',
        )})`,
      );
      console.log(this.el.nativeElement);
      console.groupEnd();
    }
    /* eslint-enable no-console */
  }
}
